export const useRuntimeAdminFlag = () => false
